import { FlexItem } from "playbook-ui";

const PbFlexItem = FlexItem;

export default PbFlexItem
